module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_01-a35ae51d4c8654f78e7229c761b18753.png";